export default __webpack_public_path__ + "static/IMG_8191-44c58d73c9ee1340e2dd41a19a5ce516.jpeg";